/* src/app/forms/painel-correios/painel-correios.component.scss */
.main-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.grid-content {
  height: 100%;
  display: grid;
  flex-direction: column;
  padding-top: 10px;
}
.header-options {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1 1 auto;
  background: rgba(0, 0, 0, 0.03);
  padding: 5px;
  font-size: 100%;
  justify-content: space-between;
}
.card-model {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-title {
  font-size: 180%;
}
.card-content {
  height: 100%;
  width: 100%;
}
.disabled {
  pointer-events: none;
  opacity: 0.3;
}
/*# sourceMappingURL=painel-correios.component.css.map */
